import React from "react";
import "./WeddingFooterComponent.scss";
import pmyg from "./pmyg.png";

const WeddingFooterComponent = ({
  weddingData = null,
  slug = null,
  canShowSeatingArrangement = false,
  canShowRsvp = true,
}) => {
  const bride_name = weddingData?.bride_name || "Bride";
  const groom_name = weddingData?.groom_name || "Groom";

  const scrollToSelector = (selector) => {
    const el = document.querySelector(selector);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
      return true;
    }
    return false;
  };

  const handleRsvpClick = () => {
    const found = scrollToSelector(".home-rsvpSection");
    if (!found && slug) {
      window.location.href = `/sites/${slug}/rsvp`;
    }
  };

  const handleTableSearchClick = () => {
    const found = scrollToSelector(".home-seatSection");
    if (!found && slug) {
      window.location.href = `/sites/${slug}/tablesearch`;
    }
  };

  const handleTopClick = () => {
    const found = scrollToSelector(".home-hero");
    if (!found) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const ceremonyTypeRaw = weddingData?.ceremony_type || "wedding";
  const isHomeComing = (() => {
    const normalized = String(ceremonyTypeRaw).trim().toLowerCase();
    return (
      normalized === "home coming" ||
      normalized === "homecoming" ||
      normalized === "home-coming"
    );
  })();

  return (
    <footer className="pmygFooter-root" role="contentinfo">
      <div className="pmygFooter-inner">
        <div className="pmygFooter-top">
          <div className="pmygFooter-brand">
            <img className="pmygFooter-logo" src={pmyg} alt="Plan My Guest" />

            <div className="pmygFooter-brandText">
              <p className="pmygFooter-kicker">Powered by</p>
              <h3 className="pmygFooter-title">Plan My Guest</h3>
              <p className="pmygFooter-couple">
                Celebrating{" "}
                {isHomeComing ? (
                  <span>
                    <span>{groom_name}</span> &amp; <span>{bride_name}</span>
                  </span>
                ) : (
                  <span>
                    <span>{bride_name}</span> &amp; <span>{groom_name}</span>
                  </span>
                )}
              </p>
            </div>
          </div>

          <div className="pmygFooter-actions">
            {canShowRsvp && (
              <button
                type="button"
                className="pmygFooter-btn"
                onClick={handleRsvpClick}
              >
                RSVP
              </button>
            )}

            {canShowSeatingArrangement && (
              <button
                type="button"
                className="pmygFooter-btn pmygFooter-btn--ghost"
                onClick={handleTableSearchClick}
              >
                Table Search
              </button>
            )}

            <button
              type="button"
              className="pmygFooter-btn pmygFooter-btn--soft"
              onClick={handleTopClick}
            >
              Back to Top
            </button>
          </div>
        </div>

        <div className="pmygFooter-divider" />

        <div className="pmygFooter-bottom">
          <div className="pmygFooter-contact">
            <p className="pmygFooter-line">
              Call <a href="tel:+94705367980">+94 70 536 7980</a>
            </p>
            <p className="pmygFooter-line">
              Email{" "}
              <a href="mailto:planmyguestbookings@gmail.com">
                planmyguestbookings@gmail.com
              </a>
            </p>
            <p className="pmygFooter-line">
              Web{" "}
              <a
                href="https://www.planmyguest.com"
                target="_blank"
                rel="noreferrer"
              >
                www.planmyguest.com
              </a>
            </p>
          </div>

          <p className="pmygFooter-copy">
            Create your wedding/homecoming website with <strong>Plan My Guest</strong>.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default WeddingFooterComponent;